import {
  useSidebarOpenState,
  useSidebarPinState,
} from '@backstage/core-components';
import { Switch } from '@material-ui/core';

import styles from './sidebar-pin-toggle.module.css';

const LABEL = 'Pin sidebar';

/**
 * The "Pin sidebar" row at the bottom of the sidebar, meant for the
 * `SidebarControl` slot.
 *
 * @remarks
 * The switch shows and flips core's pin state, which `SidebarPage` keeps in
 * localStorage. It follows `isPinned`, not `isOpen`, because hovering opens
 * the sidebar without pinning it. Between 600 and 1279 wide core disables the
 * hover expansion, so this switch is then the only way to open the sidebar.
 * The switch comes first, so it keeps its place when hovering opens the
 * sidebar. Open, the label stands to the right of it. Compact, only the switch
 * shows, and the input keeps "Pin sidebar" as its accessible name in both
 * states. On mobile it renders nothing, because pinning does not exist there.
 *
 * @public
 */
export const SidebarPinToggle = () => {
  const { isMobile, isPinned, toggleSidebarPinState } = useSidebarPinState();
  const { isOpen } = useSidebarOpenState();

  if (isMobile) {
    return null;
  }

  return (
    <div className={styles.root}>
      <hr aria-hidden="true" className={styles.divider} />
      <div className={styles.row}>
        <Switch
          checked={isPinned}
          className={styles.switch}
          inputProps={{ 'aria-label': LABEL }}
          onChange={() => toggleSidebarPinState()}
        />
        {isOpen && <span className={styles.label}>{LABEL}</span>}
      </div>
    </div>
  );
};
